import React, { Component } from 'react';
import Select, { ActionMeta, MultiValue, SingleValue } from 'react-select';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Option from '../../interfaces/Option/Option';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import FormFieldSelectProps from './FormFieldSelect.props';
import FormFieldSelectState from './FormFieldSelect.state';
import { CustomDropdownIndicator, CustomInput } from './FormFieldSelectPartials';
import { formFieldSelectStylesForCustomerDataPage, formFieldSelectStylesForProductPropertiesOverlay } from './FormFieldSelectStyles';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import { FormFieldName } from '../../interfaces/ProductProperties/ProductProperties';

export default class FormFieldSelect extends Component<FormFieldSelectProps, FormFieldSelectState> implements FormFieldFunctions {
    private selectElement: React.RefObject<HTMLDivElement>;
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: FormFieldSelectProps) {
        super(props);
        this.state = {
            selected: this.props.selected,
            preSelected: !this.props.isLoggedIn ? false : (this.props.selected && this.props.selected !== '' && this.props.selected !== 'default' ? true : false)
        };

        this.selectElement = React.createRef<HTMLDivElement>();
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.isValid = this.isValid.bind(this);
        this.toggleValidationError = this.toggleValidationError.bind(this);
    }

    componentDidMount() {
        try {
            window.Juris.moduleRegistry.autoApplyModule('Tooltip', '#' + this.props.id + 'Tooltip');
        } catch (error) {
            console.log(error);
        }

        this.props.onChangePaymentPeriod && this.props.onChangePaymentPeriod(this.state.selected || '');
        if (this.props.name === FormFieldName.FRAMEWORKCONTRACT) {
            this.context.globalStates.setSelectedFrameworkContract(this.state.selected as string, this.props.name as string);
        }
    }

    handleSelectChange(newValue: MultiValue<Option> | SingleValue<Option>, actionMeta: ActionMeta<Option>) {
        const selected = newValue && !Array.isArray(newValue) ? (newValue as Option).value : undefined;
        this.context.globalStates.setSelectedFrameworkContract(selected as string, this.props.name as string);
        // console.log('selected in formFieldSelect: ', this.context.globalStates.getSelectedFrameworkContract());
        this.setState({
            selected: selected,
        }, () => {
            this.props.onChange && this.props.onChange();
            this.props.onChangeMagicNumber && this.props.onChangeMagicNumber(this.state.selected || '');
            this.props.onChangePaymentPeriod && this.props.onChangePaymentPeriod(this.state.selected || '');
            this.props.onTradeChange && this.props.onTradeChange(selected as string | null);
        });
    }

    updateAndNotify = () => {
        console.log('update loggedIn: ', this.props.isLoggedIn)
        this.setState({
            selected: this.props.selected,
            preSelected: !this.props.isLoggedIn ? false : (this.props.selected && this.props.selected !== '' && this.props.selected !== 'default' ? true : false)
        });
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldSelectProps): Snapshot {
        return { notifyRequired: prevProps.selected !== this.props.selected };
    }

    componentDidUpdate(prevProps: FormFieldSelectProps, prevState: FormFieldSelectState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
        // if (prevState.preSelected !== this.state.preSelected) {
        //     this.setState({
        //         preSelected: !this.props.isLoggedIn ? false : (this.props.selected && this.props.selected !== '' && this.props.selected !== 'default' ? true : false)
        //     });
        // }
        if (prevProps.isLoggedIn !== this.props.isLoggedIn) {
            console.log('time is now')
            this.setState({
                preSelected: !this.props.isLoggedIn ? false : (this.props.selected && this.props.selected !== '' && this.props.selected !== 'default' ? true : false)
            });
        }
    }

    onBlur() {
        if (this.isValid()) {
            this.toggleValidationError(false);
        }
    }

    isValid() {
        if (this.props.required && (this.state.selected === undefined || this.state.selected.trim() === '')) {
            return false;
        }

        return true;
    }

    toggleValidationError(show: boolean) {
        if (show) {
            this.selectElement.current?.parentElement?.classList.add('form__field--error');
        } else {
            this.selectElement.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    getValue() {
        return this.state.selected;
    }

    render(): React.ReactNode {
        return (
            <div className={"form__col col col-12" + (this.props.hidden ? " d-none" : "")}
                data-testid="FormFieldWrapper">
                <div className="form__field">
                    <div data-testid="FormFieldSelect"
                        className={
                            "select"
                            + (this.props.noAlternative ? "" : " select--alternative")
                            + (!!this.state.selected && this.state.selected !== 'default' ? " select--option-selected" : "")
                        }
                        id={this.props.id + 'Container'}
                        ref={this.selectElement}
                        style={this.props.readOnly ? {
                            pointerEvents: "none",
                        } : undefined}>
                        {(!this.props.noAlternative) && this.props.label &&
                            <label className="select__label" htmlFor={this.props.id}>{this.props.label}</label>
                        }
                        {
                            this.props.info
                                ? <div className="select__info" data-tooltip={false} id={this.props.id + 'Tooltip'}>
                                    <span className="icon_error-circle_alt"></span>
                                    {
                                        this.props.info.label
                                            ? <span className="select__info-label">{this.props.info.label}</span>
                                            : null
                                    }
                                    {
                                        this.props.noAlternative
                                            ? <div className="select__info-tooltip"
                                                data-tooltip-content={false}
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}>
                                            </div>
                                            : <div className="select__info-tooltip"
                                                data-tooltip-content={false}>
                                                <span className="icon_error-circle_alt"></span>
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.props.info.text
                                                }}></div>
                                                <span className="cta-overlay-button__close-btn-icon"></span>
                                            </div>
                                    }
                                </div>
                                : null
                        }
                        <div className="select__inner" style={{
                            borderBottom: 'none',
                            padding: 'none',
                        }}>
                            <div className="select__content">
                                {this.props.noAlternative && this.props.label &&
                                    <label className="select__label" htmlFor={this.props.id}>{this.props.label}</label>
                                }
                                <Select
                                    inputId={this.props.id}
                                    tabIndex={undefined}
                                    tabSelectsValue={false}
                                    maxLength={this.props.maxLength}
                                    name={this.props.name || this.props.id}
                                    value={this.props.options.find(option => option.value === this.state.selected)}
                                    options={this.props.options}
                                    placeholder={this.props.label}
                                    // defaultMenuIsOpen={true} // for debug purposes
                                    isDisabled={this.props.readOnly || (this.props.isLoggedIn && this.state.preSelected && this.props.required) || (this.state.preSelected && !this.props.isLoggedIn)}
                                    closeMenuOnSelect={!this.props.multiple}
                                    isMulti={this.props.multiple}
                                    onChange={this.handleSelectChange}
                                    noOptionsMessage={() => "Keine Optionen"}
                                    onBlur={this.onBlur}
                                    styles={
                                        this.props.noAlternative
                                            ? formFieldSelectStylesForCustomerDataPage
                                            : formFieldSelectStylesForProductPropertiesOverlay
                                    }
                                    components={{
                                        DropdownIndicator: CustomDropdownIndicator,
                                        Input: CustomInput,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        this.props.hint
                            ? <span className="form__field-hint">{this.props.hint}</span>
                            : null
                    }
                    {
                        this.props.errorMessage
                            ? <div className="form__field-error-message">{this.props.errorMessage}</div>
                            : null
                    }
                </div>
            </div>
        );
    }
}
